import { Title } from "melco-ui";
import { StatisticsBarChart } from "./StatisticsBarChart";
import { StatisticsConfig } from "../../../../hooks/reporting/statistics/useStatistics";
import { ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

type AmountOfRunsProps = {
  dataConfig?: StatisticsConfig;
  data?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem;
  isLoading: boolean;
};

export const AmountOfRuns: React.FC<AmountOfRunsProps> = ({
  data,
  dataConfig,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Title level={5}>{t("reporting.statistics.charts.amount_of_runs")}</Title>
      <StatisticsBarChart
        field="runs"
        dataConfig={{ ...dataConfig, sortBy: "runs" }}
        data={data}
        isLoading={isLoading}
      />
    </>
  );
};
